import type { RoleCode, StudyTypeField } from '../lib/types';
import { Field } from './ui';

export function DynamicFields({
  fields,
  values,
  onChange,
  role,
}: {
  fields: StudyTypeField[];
  values: Record<string, unknown>;
  onChange: (code: string, value: unknown) => void;
  role?: RoleCode | undefined;
}) {
  const visible = fields.filter((field) => field.active && (!field.appliesToRole || !role || field.appliesToRole === role));
  if (!visible.length) return <p className="muted">Este tipo de estudio no tiene campos adicionales configurados para este rol.</p>;
  return (
    <div className="form-grid two">
      {visible.map((field) => {
        const value = values[field.code];
        if (field.fieldType === 'BOOLEAN') {
          return (
            <Field key={field.id} label={field.label} required={field.required} hint={field.helpText ?? undefined}>
              <label className="switch-line"><input type="checkbox" checked={Boolean(value)} onChange={(event) => onChange(field.code, event.target.checked)} /> Sí</label>
            </Field>
          );
        }
        if (field.fieldType === 'SELECT') {
          return (
            <Field key={field.id} label={field.label} required={field.required} hint={field.helpText ?? undefined}>
              <select required={field.required} value={typeof value === 'string' ? value : ''} onChange={(event) => onChange(field.code, event.target.value)}>
                <option value="">Seleccione…</option>
                {(field.options ?? []).map((option) => <option key={option} value={option}>{option}</option>)}
              </select>
            </Field>
          );
        }
        if (field.fieldType === 'MULTISELECT') {
          const selected = Array.isArray(value) ? value.map(String) : [];
          return (
            <Field key={field.id} label={field.label} required={field.required} hint={field.helpText ?? undefined}>
              <select multiple value={selected} onChange={(event) => onChange(field.code, Array.from(event.target.selectedOptions).map((option) => option.value))}>
                {(field.options ?? []).map((option) => <option key={option} value={option}>{option}</option>)}
              </select>
            </Field>
          );
        }
        if (field.fieldType === 'TEXTAREA') {
          return <Field key={field.id} label={field.label} required={field.required} hint={field.helpText ?? undefined}><textarea rows={4} required={field.required} value={typeof value === 'string' ? value : ''} onChange={(event) => onChange(field.code, event.target.value)} /></Field>;
        }
        const type = field.fieldType === 'NUMBER' ? 'number' : field.fieldType === 'DATE' ? 'date' : field.fieldType === 'DATETIME' ? 'datetime-local' : 'text';
        return <Field key={field.id} label={field.label} required={field.required} hint={field.helpText ?? undefined}><input type={type} required={field.required} value={value == null ? '' : String(value)} onChange={(event) => onChange(field.code, field.fieldType === 'NUMBER' && event.target.value !== '' ? Number(event.target.value) : event.target.value)} /></Field>;
      })}
    </div>
  );
}
